"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TagsPart_1;
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label class="">${x => x.label.t()}</label>`)}
    
    
    <div class="tags-holder">
        <div class="tags-container">
            ${T.repeat(x => x.displayTags || [], T.html `
                <span class="tags-badge badge-${(x, c) => c.parent.badgeStyle || 'primary'}">
                    ${tag => tag}
                    <span class="tags-badge-close" @click="${(tag, c) => c.parent.removeTag(c.index)}">&times;</span>
                </span>
            `)}
            <input 
                type="text"
                class="tags-input"
                placeholder="${x => x.placeholder ? x.placeholder.t() : ''}"
                @keydown="${(x, c) => x.handleInputKeydown(c.event)}"
                @input="${(x, c) => x.handleInputChange(c.event)}"
                @focus="${x => x.showAllSuggestions()}"
                @blur="${x => x.hideSuggestions()}"
                ?disabled="${x => x.max && x.displayTags && x.displayTags.length >= x.max}"
            />
        </div>
    </div>
    ${(0, fast_element_1.when)(x => x.filteredSuggestions && x.filteredSuggestions.length > 0 && x.showSuggestions, T.html `
        <div class="tags-suggestions">
            ${T.repeat(x => x.filteredSuggestions, T.html `
                <div class="tags-suggestion-item" @mousedown="${(x, c) => c.parent.selectSuggestion(x)}">
                    ${s => s.label}
                </div>
            `)}
        </div>
    `)}
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

:host .tags-holder {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--text_color, #3a3a3a);
  background-image: none;
  border: 1px solid var(--bs-border-color, #dee2e6);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
:host .tags-holder:focus-within {
  color: var(--text_color, #3a3a3a);
  border-color: rgba(146, 44, 136, 0.6);
  outline: 0;
}
:host .tags-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}
:host .tags-input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  min-width: 60px;
  padding: 0;
  margin: 0;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
:host .tags-input::placeholder {
  color: var(--bs-form-control-placeholder-color, #6c757d);
  opacity: 1;
}
:host .tags-input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
:host .tags-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25em 0.5em;
  font-size: 0.875em;
  font-weight: 500;
  line-height: 1;
  color: var(--bs-white, #fff);
  background-color: var(--bs-primary, #0d6efd);
  border-radius: 0.375rem;
}
:host .tags-badge.badge-secondary {
  background-color: var(--bs-secondary, #6c757d);
}
:host .tags-badge.badge-success {
  background-color: var(--bs-success, #198754);
}
:host .tags-badge.badge-danger {
  background-color: var(--bs-danger, #dc3545);
}
:host .tags-badge.badge-warning {
  background-color: var(--bs-warning, #ffc107);
  color: var(--bs-dark, #212529);
}
:host .tags-badge.badge-info {
  background-color: var(--bs-info, #0dcaf0);
  color: var(--bs-dark, #212529);
}
:host .tags-badge.badge-light {
  background-color: var(--bs-light, #f8f9fa);
  color: var(--bs-dark, #212529);
}
:host .tags-badge.badge-dark {
  background-color: var(--bs-dark, #212529);
}
:host .tags-badge-close {
  margin-left: 0.5em;
  cursor: pointer;
  opacity: 0.7;
  font-weight: bold;
  user-select: none;
}
:host .tags-badge-close:hover {
  opacity: 1;
}
:host .tags-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--bs-body-bg, #fff);
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
:host .tags-suggestion-item {
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  cursor: pointer;
  color: var(--text_color, #3a3a3a);
}
:host .tags-suggestion-item:hover {
  background: var(--bs-primary, #0d6efd);
  color: #fff;
}
:host.is-invalid .tags-holder {
  border-color: var(--bs-danger, #dc3545);
}
:host.is-invalid .tags-holder:focus-within {
  border-color: var(--bs-danger, #dc3545);
  box-shadow: 0 0 0 var(--bs-focus-ring-width, 0.25rem) rgba(var(--bs-danger-rgb, 220, 53, 69), 0.25);
}
:host.is-valid .tags-holder {
  border-color: var(--bs-success, #198754);
}
:host.is-valid .tags-holder:focus-within {
  border-color: var(--bs-success, #198754);
  box-shadow: 0 0 0 var(--bs-focus-ring-width, 0.25rem) rgba(var(--bs-success-rgb, 25, 135, 84), 0.25);
}
:host.form-control-disabled .tags-holder {
  background-color: var(--bs-form-control-disabled-bg, var(--bs-secondary-bg, #e9ecef));
  opacity: 1;
  cursor: not-allowed;
}
:host.form-control-disabled .tags-holder .tags-input {
  cursor: not-allowed;
}
:host.form-control-disabled .tags-holder .tags-badge-close {
  pointer-events: none;
}
:host.is-max-reached .tags-input {
  display: none;
}`;
const shadowOptions = { "mode": "open" };
let TagsPart = TagsPart_1 = class TagsPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = [];
        this.ignored = 'false';
        this.dontEmit = false;
        this.allowNew = 'true';
        this.separator = ',';
        this.badgeStyle = 'primary';
        this.currentInput = '';
        this.displayTags = [];
        this.filteredSuggestions = [];
        this.showSuggestions = false;
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    valueChanged(oldValue, newValue) {
        this.displayTags = newValue || [];
        console.log(this.displayTags);
    }
    getElement() {
        // Return the input element for form validation
        const input = this.$('.tags-input');
        // Create a custom validation method for tags
        if (input && !input.hasAttribute('data-tags-validation-setup')) {
            input.setAttribute('data-tags-validation-setup', 'true');
            // Override checkValidity to check if tags are required
            const originalCheckValidity = input.checkValidity.bind(input);
            input.checkValidity = () => {
                if (this.isRequired && (!this.displayTags || this.displayTags.length === 0)) {
                    input.setCustomValidity('At least one tag is required');
                    return false;
                }
                else {
                    input.setCustomValidity('');
                    return originalCheckValidity();
                }
            };
        }
        return input;
    }
    connectedCallback() {
        super.connectedCallback();
        this.displayTags = this.value || [];
        this.filteredSuggestions = [];
    }
    // Manual tag management
    handleInputKeydown(event) {
        const input = event.target;
        // const separators = this.separator?.split(',') || [','];
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission
            event.stopPropagation(); // Stop event bubbling
            this.addTag(input.value.trim());
            input.value = '';
            this.currentInput = '';
            return false;
        }
        if (event.key === 'Backspace' && this.currentInput === '') {
            event.preventDefault(); // Prevent form submission
            event.stopPropagation(); // Stop event bubbling
            this.removeTag(this.displayTags.length - 1);
            return false;
        }
        this.currentInput = input.value.trim();
        return true;
    }
    handleInputChange(event) {
        const input = event.target;
        this.currentInput = input.value;
        this.updateFilteredSuggestions(input.value);
    }
    showAllSuggestions() {
        if (!this.suggestions || !this.suggestions.length)
            return;
        const current = this.displayTags || [];
        this.filteredSuggestions = this.suggestions.filter(s => !current.includes(s.value));
        this.showSuggestions = this.filteredSuggestions.length > 0;
    }
    updateFilteredSuggestions(query) {
        if (!this.suggestions || !this.suggestions.length) {
            this.filteredSuggestions = [];
            this.showSuggestions = false;
            return;
        }
        const q = query.toLowerCase().trim();
        const current = this.displayTags || [];
        this.filteredSuggestions = this.suggestions.filter(s => !current.includes(s.value) && (!q || s.label.toLowerCase().includes(q) || s.value.toLowerCase().includes(q)));
        this.showSuggestions = this.filteredSuggestions.length > 0;
    }
    selectSuggestion(suggestion) {
        this.addTag(suggestion.value);
        const input = this.$('.tags-input');
        if (input)
            input.value = '';
        this.currentInput = '';
        this.filteredSuggestions = [];
        this.showSuggestions = false;
    }
    hideSuggestions() {
        // defer so mousedown on suggestion fires first
        setTimeout(() => { this.showSuggestions = false; }, 150);
    }
    addTag(tagValue) {
        if (!tagValue || (this.max && this.displayTags && this.displayTags.length >= this.max))
            return;
        const currentTags = this.displayTags || [];
        if (!currentTags.includes(tagValue)) {
            const newTags = [...currentTags, tagValue];
            this.value = newTags;
            this.displayTags = newTags;
            // Trigger change event for form integration
            this.triggerChangeEvent();
        }
    }
    removeTag(index) {
        const currentTags = this.displayTags || [];
        if (index >= 0 && index < currentTags.length) {
            const newTags = currentTags.filter((_, i) => i !== index);
            this.value = newTags;
            this.displayTags = newTags;
            // Trigger change event for form integration
            this.triggerChangeEvent();
        }
    }
    triggerChangeEvent() {
        this.handleChange({
            target: {
                name: this.name,
                value: this.displayTags
            }
        });
        // Also dispatch standard "change" event for broader compatibility
        this.$emit('change', {
            value: this.displayTags,
            name: this.name,
            formPartType: TagsPart_1.PART_TYPE
        });
    }
    reset() {
        this.value = [];
        this.displayTags = [];
        this.currentInput = '';
    }
};
exports.TagsPart = TagsPart;
TagsPart.PART_TYPE = 'tags';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TagsPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], TagsPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "allowNew", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "separator", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], TagsPart.prototype, "max", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TagsPart.prototype, "badgeStyle", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TagsPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], TagsPart.prototype, "suggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TagsPart.prototype, "currentInput", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TagsPart.prototype, "displayTags", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], TagsPart.prototype, "filteredSuggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TagsPart.prototype, "showSuggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], TagsPart.prototype, "onChange", void 0);
exports.TagsPart = TagsPart = TagsPart_1 = __decorate([
    (0, client_1.RWSView)('part-tags', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TagsPart);
TagsPart.defineComponent();
